module.exports = __webpack_public_path__ + "static/media/CGoldFrame.3a34a98a.png";